<template>
  <div class="reviewContent">
    <div v-if="newLastOne "  style="margin-top:1rem;">
      <!-- <SfAccordion class="productAcction">
        <SfAccordionItem class="filters__accordion-item" :header="$t('reviewDetail')"> -->
          <SfHeading :level="4" class="sf-heading--left sf-heading--no-underline title" :title="$t('reviewDetail')">
          </SfHeading>
          <div>
            <div class="product__description" style="margin-top:1rem;">
              {{ reviewGetters.getReviewMessage(newLastOne) }}
            </div>
            <div style="margin-top:1rem;">
              <div class="reviewImageList" style="display: flex;flex-wrap: wrap;gap: 1rem;">
                <div v-if="newLastOne&&newLastOne.videoUrl">
                  <video :autoplay="false" muted preload="load" loop
                    :src="newLastOne.videoUrl" :width="'100%'"
                    :height=" '100%'" style="object-position: top;max-height:150px;max-width: 150px;"
                    controls="controls" playsinline>
                    <source :src="newLastOne.videoUrl" :type="'video/*'">
                  </video>
                </div>
                <Sf-image v-for="imgsrc in reviewGetters.getReviewImages(newLastOne)" style="--image-height:150px;object-fit: contain;margin:0;display: block;" :src="imgsrc" :alt="imgsrc" />
              </div>
            </div>
          </div>
        <!-- </SfAccordionItem>
      </SfAccordion> -->
    </div>
  </div>
</template>
<script>
import { computed } from '@nuxtjs/composition-api';
import { useReview, reviewGetters } from '@bee-hole/coms';
import {
  SfHeading,
  SfImage
} from '@storefront-ui/vue';
export default {
  name: 'ReviewContent',
  props: {
    order: {
      type: Object,
      default: {}
    },
    grade: 1,
    goodsId: 0,
    skuId: 0,
    itemName: ''
  },
  setup(props) {
    const goodsId = props.goodsId;
    const skuId = props.skuId ? props.skuId : 0;
    const { reviews } = useReview(
      'productReview_' + goodsId + '_' + skuId
    );
    const newLastOne = computed(() => reviews.value[0]);
    return {
      reviewGetters,
      newLastOne
    };
  },
  components: {
    SfHeading,
    SfImage
  }
};
</script>
<style lang="scss">
.reviewContent{
  .sf-heading{
    .sf-heading__title.h4{
      // font-size: 1.25rem;
      font-weight: 600;
      line-height: 1.2;
    }
  }
}
</style>
